import { Client, Server } from "components/Docs/Integrate";
import * as React from 'react';
export default {
  Client,
  Server,
  React
};